import './styles.css';

export default function InstructorAccountItemCheckbox({ 
  label,
  isChecked,
  onCheck,
  disabled,
  title
}) {
  const checkboxId = `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div 
      className={`account-item-checkbox ${disabled ? 'disabled' : ''}`}
      title={title ? title : ''}
    >
      <input 
        type="checkbox"
        id={checkboxId} 
        checked={isChecked} 
        onChange={onCheck}
        disabled={disabled}
      />
      <label htmlFor={checkboxId}>{label}</label>
    </div>
  );
}